import Vue from 'vue';

const UTM_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
];

const SHORTSHIFT_ORIGIN = 'https://mg.shortshift.io';

Vue.component('custom-norway-configurator', {
    props: {
        iframeSrc: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            iframeHeight: 1800,
            iframeSrcByModel: {
                mgs5: 'https://mg.shortshift.io/mg/s5',
                mgs6: 'https://mg.shortshift.io/mg/s6',
                mg4: 'https://mg.shortshift.io/mg/mg4',
                im5: 'https://mg.shortshift.io/mg/im5',
                im6: 'https://mg.shortshift.io/mg/im6',
                cyberster: 'https://mg.shortshift.io/mg/cyberster',
            },
        };
    },

    mounted() {
        window.addEventListener('message', this.onMessage);
    },

    beforeDestroy() {
        window.removeEventListener('message', this.onMessage);
    },

    methods: {
        onMessage(event) {
            const isFromShortShift =
                event.origin === SHORTSHIFT_ORIGIN &&
                event.source === this.$refs.iframe?.contentWindow;

            const isResizeEventDataSet =
                isFromShortShift &&
                event.data &&
                event.data.type === 'resize' &&
                event.data.height;

            const isScrollToTopEventDataSet =
                isFromShortShift &&
                event.data &&
                event.data.type === 'scrollToTop';

            if (isResizeEventDataSet) {
                this.iframeHeight = event.data.height;
            }

            if (isScrollToTopEventDataSet) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }

            const isUtmParamsRequest =
                isFromShortShift &&
                event.data &&
                event.data.type === 'utmParams' &&
                event.data.action === 'requestUtmParams';

            if (isUtmParamsRequest) {
                this.postUtmParams();
            }
        },

        readCookie(name) {
            if (!document.cookie) return '';
            const nameEq = name + '=';
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                const c = ca[i].trim();
                if (c.startsWith(nameEq)) {
                    return c.substring(nameEq.length);
                }
            }
            return '';
        },

        getUtmParams() {
            const params = {};
            for (const key of UTM_PARAMS) {
                const value = this.readCookie(`/utm/${key}`);
                if (value) {
                    params[key] = value;
                }
            }
            return params;
        },

        postUtmParams() {
            const params = this.getUtmParams();
            if (!Object.keys(params).length) return;

            const iframe = this.$refs.iframe;
            if (!iframe || !iframe.contentWindow) return;

            iframe.contentWindow.postMessage(
                {
                    realm: 'shortshift',
                    type: 'utmParams',
                    params,
                },
                SHORTSHIFT_ORIGIN,
            );
        },

        setIframeSrcByUrl() {
            const searchParams = new URLSearchParams(window.location.search);
            const isModelInSearchParams = searchParams.has('model');

            if (!isModelInSearchParams) return this.iframeSrc;

            const model = searchParams.get('model');
            return this.iframeSrcByModel[model];
        },
    },

    template: `
        <div class="custom-norway-configurator">
            <iframe
                ref="iframe"
                :src="setIframeSrcByUrl()"
                :style="{ height: iframeHeight + 'px' }"
                width="100%"
                frameborder="0"
                scrolling="no"
                @load="postUtmParams"
            ></iframe>
        </div>
    `,
});
